/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cursus.rpc.SendConfigurationRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getSendAsSettingsForUserRpc = {
  serviceName: 'com.hubspot.cursus.rpc.SendConfigurationRpc',
  rpcName: 'getSendAsSettingsForUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAXvDAnIZJ0KpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalUnsubscribeLinkSettingsRpc = {
  serviceName: 'com.hubspot.cursus.rpc.SendConfigurationRpc',
  rpcName: 'getPortalUnsubscribeLinkSettings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAASXMIG7TGyrJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserUnsubscribeLinkSettingsRpc = {
  serviceName: 'com.hubspot.cursus.rpc.SendConfigurationRpc',
  rpcName: 'getUserUnsubscribeLinkSettings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAASXMIG7TGyrJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setPortalUnsubscribeLinkSettingsRpc = {
  serviceName: 'com.hubspot.cursus.rpc.SendConfigurationRpc',
  rpcName: 'setPortalUnsubscribeLinkSettings',
  auth: 'app',
  fingerprint: 'jz29niGZIkWOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteSendAsSettingsRpc = {
  serviceName: 'com.hubspot.cursus.rpc.SendConfigurationRpc',
  rpcName: 'deleteSendAsSettings',
  auth: 'app',
  fingerprint: 'xTHWURVwJxGOUe2e_r4XmWGeNmH3ZPI0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};